/* Custom tattoo ad landing (sections/cl-landing.liquid): size cards (phones: tap = sheet view +
   info box with "Weiter"; desktop: hover in CSS, click = Custom Studio with that size), scroll reveal, videos that only play while visible (tap for
   sound), step animations, rail arrows and the sticky bar on phones. Without JS every card is a plain link to its
   product page and the page is fully readable. */
(function () {
  /* the section can sit twice on the page (setting «part»: top + rest, page plan 21.10.2026) – every part gets its own run */
  [].forEach.call(document.querySelectorAll('section.cl'), function (sec) {
  if (sec.__cl) return;
  sec.__cl = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (reduce || !hasIO) sec.classList.add('czl--still');

  function onView(el, cb, opts) {
    if (!hasIO) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting, e); }); }, opts || { threshold: 0.3 }).observe(el);
  }

  /* reveal on scroll (content stays visible without JS or with reduced motion) */
  if (!reduce && hasIO) {
    sec.classList.add('czl--anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.classList.add('is-in'); io.unobserve(el);
        setTimeout(function () { el.removeAttribute('data-czl-r'); el.classList.remove('is-in'); }, 1400);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    sec.querySelectorAll('[data-czl-r]').forEach(function (el) { io.observe(el); });
  }

  /* size cards: on phones / touch a tap shows the sheet view and opens the compact info box, "Weiter" (or a second tap
     on the same card) opens the Custom Studio with that size */
  var desktop = window.matchMedia('(hover: hover) and (min-width: 990px)');
  var sheet = sec.querySelector('[data-cl-sheet]');
  var active = null, closeT = 0;
  function sheetOpen() { return sheet && !sheet.hidden; }
  function closeSheet() {
    if (!sheetOpen()) return;
    sheet.classList.remove('is-open');
    if (active) active.classList.remove('is-active');
    active = null;
    clearTimeout(closeT);
    closeT = setTimeout(function () { sheet.hidden = true; updateSticky(); }, reduce ? 0 : 300);
  }
  function openSheet(card) {
    if (active && active !== card) active.classList.remove('is-active');
    active = card; card.classList.add('is-active');
    clearTimeout(closeT);
    sheet.querySelector('[data-cl-sheet-name]').textContent = card.getAttribute('data-cl-name');
    sheet.querySelector('[data-cl-sheet-suffix]').textContent = card.getAttribute('data-cl-suffix') || '';
    sheet.querySelector('[data-cl-sheet-cm]').textContent = card.getAttribute('data-cl-cm');
    sheet.querySelector('[data-cl-sheet-from]').textContent = card.getAttribute('data-cl-from');
    sheet.querySelector('[data-cl-sheet-text]').textContent = card.getAttribute('data-cl-short') || '';
    sheet.querySelector('[data-cl-sheet-go]').setAttribute('href', card.getAttribute('href'));
    sheet.hidden = false;
    updateSticky();
    requestAnimationFrame(function () { requestAnimationFrame(function () { sheet.classList.add('is-open'); }); });
  }
  sec.querySelectorAll('[data-cl-card]').forEach(function (card) {
    card.addEventListener('click', function (ev) {
      if (desktop.matches || !sheet) return; /* desktop: plain link to the product page */
      if (active === card && sheetOpen()) return; /* second tap: go */
      ev.preventDefault();
      openSheet(card);
    });
  });
  if (sheet) {
    sheet.querySelector('[data-cl-sheet-close]').addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
    document.addEventListener('click', function (e) {
      if (!sheetOpen() || e.target.closest('[data-cl-sheet]') || e.target.closest('[data-cl-card]')) return;
      closeSheet();
    });
    desktop.addEventListener && desktop.addEventListener('change', closeSheet);
  }

  /* sticky bar (phones): only while neither the hero, the size cards nor the final CTA are on screen */
  var sticky = sec.querySelector('[data-cl-sticky]');
  var seen = { hero: true, order: false, final: false };
  function updateSticky() {
    if (!sticky) return;
    var on = !seen.hero && !seen.order && !seen.final && !sheetOpen();
    sticky.classList.toggle('is-on', on);
  }
  if (sticky && hasIO) {
    [['hero', '.cl-hero'], ['order', '#cl-order'], ['final', '.czl-final']].forEach(function (k) {
      var el = document.querySelector(k[1]); if (!el) { seen[k[0]] = false; return; }
      onView(el, function (vis) { seen[k[0]] = vis; updateSticky(); }, { threshold: 0 });
    });
  }

  /* videos (hero collage + reel): muted loop while visible; if autoplay is refused a play button appears; tapping a reel
     video plays it with sound and mutes the others */
  var vids = [].slice.call(sec.querySelectorAll('[data-czl-video] video'));
  var saveData = navigator.connection && navigator.connection.saveData;
  function tryPlay(v) {
    var item = v.closest('.czl-reel__item');
    /* hero: the mp4 is only set now (snippets/cz-hero-collage: data-lazy-src, smaller copy on phones, sharper one on 2x desktop screens) */
    if (!v.getAttribute('src') && v.dataset.lazySrc) {
      var phone = window.innerWidth < 990;
      v.src = (phone && v.dataset.lazySrcSd) || (!phone && (window.devicePixelRatio || 1) >= 1.5 && v.dataset.lazySrcHd) || v.dataset.lazySrc;
    }
    if (v.preload === 'none') v.preload = 'auto';
    var pr = v.play();
    if (pr && pr.then) pr.then(function () { if (item) item.classList.remove('is-blocked'); }).catch(function () { if (item) item.classList.add('is-blocked'); });
  }
  /* hero video: start only after its poster image is on screen, so the poster (LCP) loads first */
  function afterPoster(v, cb) {
    var im = v.parentNode.querySelector('.czl-hm__poster');
    var done = false;
    var go = function () { if (!done) { done = true; cb(); } };
    if (!im || (im.complete && im.naturalWidth)) { go(); return; }
    im.addEventListener('load', go, { once: true }); im.addEventListener('error', go, { once: true });
  }
  vids.forEach(function (v) {
    var it = v.closest('.czl-reel__item');
    if (it) v.addEventListener('playing', function () { it.classList.add('is-playing'); });
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.loop = true; v.removeAttribute('controls');
    /* no autoplay with "reduce motion" or the data saver: the poster stays, a tap on a reel clip still plays it */
    if (reduce || saveData) { v.removeAttribute('autoplay'); v.pause(); return; }
    afterPoster(v, function () {
      /* visibility of the hero frame (the video itself sits 1 px inside it, see cz-landing.css), so the start point is unchanged */
      onView(v.closest('.czl-hm--video') || v, function (vis) { if (vis && !document.hidden) tryPlay(v); else v.pause(); }, { threshold: 0.35 });
    });
  });
  /* reel photos and posters: start loading shortly before the rail scrolls into view (lazy images in a horizontal rail
     would otherwise only load tile by tile while swiping) */
  var reel = sec.querySelector('.czl-reel');
  if (reel) onView(reel, function (vis) { if (vis) reel.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }, { rootMargin: '900px 0px', threshold: 0 });

  function setSound(item) {
    sec.querySelectorAll('.czl-reel__item.is-sound').forEach(function (o) {
      if (o === item) return;
      o.classList.remove('is-sound'); var ov = o.querySelector('video'); if (ov) ov.muted = true;
    });
    var v = item.querySelector('video'); if (!v) return;
    var on = !item.classList.contains('is-sound');
    v.muted = !on; item.classList.toggle('is-sound', on);
    if (on) { v.currentTime = 0; tryPlay(v); }
  }
  sec.querySelectorAll('.czl-reel__item.is-video').forEach(function (item) {
    item.addEventListener('click', function () {
      if (item.classList.contains('is-blocked')) { var v = item.querySelector('video'); if (v) tryPlay(v); return; }
      setSound(item);
    });
  });

  /* step animations run only while visible */
  sec.querySelectorAll('[data-czl-live]').forEach(function (el) {
    if (reduce) return;
    onView(el, function (vis) { el.classList.toggle('is-live', vis); if (el.hasAttribute('data-czl-size-anim')) sizeAnim(el, vis); }, { threshold: 0.25 });
  });

  /* step 1: the frame eases between sizes, the cm labels and the size pill follow (design 12 cm wide at 46 %) */
  function sizeAnim(el, run) {
    var box = el.querySelector('.czl-a2__box'), w = el.querySelector('.czl-a2__w'), h = el.querySelector('.czl-a2__h'), pills = el.querySelectorAll('.czl-a2__pills b');
    if (!run) { cancelAnimationFrame(el.__raf); el.__raf = 0; return; }
    if (el.__raf) return;
    var comma = /^de/i.test(document.documentElement.lang || '');
    var fmt = function (n) { var s = n.toFixed(1).replace(/\.0$/, ''); return comma ? s.replace('.', ',') : s; };
    var seq = [8, 12, 17, 12], t0 = performance.now(), seg = 1700;
    function frameFn(now) {
      var t = (now - t0) / seg, i = Math.floor(t) % seq.length, f = t - Math.floor(t);
      var a = seq[i], b = seq[(i + 1) % seq.length], k = f < 0.45 ? 0 : (f - 0.45) / 0.55;
      k = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      var cm = a + (b - a) * k;
      box.style.width = (cm / 12 * 46).toFixed(2) + '%';
      w.textContent = fmt(cm) + ' cm';
      h.textContent = fmt(cm * 212 / 500) + ' cm';
      var idx = cm < 9 ? 0 : cm < 13 ? 1 : cm < 18 ? 2 : 3;
      pills.forEach(function (p, j) { p.classList.toggle('is-on', j === idx); });
      el.__raf = requestAnimationFrame(frameFn);
    }
    el.__raf = requestAnimationFrame(frameFn);
  }

  /* rail arrows at the left / right edge of the rail, vertically centred on the photos (same as .plpb-nav on
     home / collection), one card per click, hidden at the start / end (W12) */
  function railArrows(nav, rail, reduce) {
    var wrap = nav.parentNode, prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]'), raf = 0;
    var update = function () {
      raf = 0;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      nav.hidden = max <= 0;
      var m = rail.querySelector('.czl-rev__img, .czl-reel__media') || rail.querySelector('li');
      if (m) { var mb = m.getBoundingClientRect(), wb = wrap.getBoundingClientRect(); if (mb.height) wrap.style.setProperty('--czl-arrow-y', Math.round(mb.top - wb.top + mb.height / 2) + 'px'); }
    };
    var soon = function () { if (!raf) raf = requestAnimationFrame(update); };
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]'); if (!btn) return;
      var item = rail.querySelector('li'), gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      var stepW = item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      rail.scrollBy({ left: Number(btn.getAttribute('data-dir')) * stepW, behavior: reduce ? 'auto' : 'smooth' });
    });
    rail.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    if ('ResizeObserver' in window) new ResizeObserver(soon).observe(rail);
    update();
  }
  sec.querySelectorAll('[data-czl-nav]').forEach(function (nav) {
    var rail = sec.querySelector('[data-czl-rail="' + nav.getAttribute('data-czl-nav') + '"]');
    if (!rail) { nav.hidden = true; return; }
    railArrows(nav, rail, reduce);
  });

  /* «So funktioniert's» in the hero: explainer video in a pop-up (starts with sound, Escape / X / tap outside closes) */
  var vm = sec.querySelector('[data-cl-vmodal]'), vOpen = sec.querySelector('[data-cl-video-open]');
  if (vm && vOpen) {
    var vClose = function () {
      if (vm.hidden) return;
      var v = vm.querySelector('video'); if (v) v.pause();
      vm.hidden = true; document.documentElement.style.overflow = ''; vOpen.focus();
    };
    vOpen.addEventListener('click', function () {
      vm.hidden = false; document.documentElement.style.overflow = 'hidden';
      var play = vm.querySelector('[data-czx-play]'), v = vm.querySelector('video');
      if (play && !play.hidden && play.offsetParent !== null) play.click(); else if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      vm.querySelector('[data-cl-vmodal-close]').focus({ preventScroll: true });
    });
    vm.addEventListener('click', function (ev) { if (ev.target === vm || ev.target.closest('[data-cl-vmodal-close]')) vClose(); });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') vClose(); });
  }

  /* smooth jumps to the size cards (all CTAs) */
  sec.addEventListener('click', function (ev) {
    var a = ev.target.closest('a[href^="#cl-"]'); if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
    ev.preventDefault();
    /* stop below the theme's sticky header (whatever is fixed / sticky at the top edge) */
    var top = 0;
    for (var y = 2; y < 220 && document.elementsFromPoint; y += 24) {
      if (y > top + 26) break; /* only bars that touch each other from the top edge */
      document.elementsFromPoint(window.innerWidth / 2, y).forEach(function (el) {
        for (var n = el; n && n !== document.body; n = n.parentElement) {
          var pos = getComputedStyle(n).position;
          if (pos === 'fixed' || pos === 'sticky') { var r = n.getBoundingClientRect(); if (r.top <= top + 2 && r.bottom < window.innerHeight / 2) top = Math.max(top, r.bottom); break; }
        }
      });
    }
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - top - 16, behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });
  });
})();
